import PhoneRinging from '../src/PhoneRinging';
export default PhoneRinging;
